import React from 'react'
import PropTypes from 'prop-types'
import styles from './ListSlatePlugin.scss'

const ListBulletedNode = ({ attributes, children }) => (
  <ul {...attributes} className={styles.ListNode}>
    {children}
  </ul>
)

ListBulletedNode.propTypes = {
  attributes: PropTypes.object,
  children: PropTypes.node
}

export default ListBulletedNode



// WEBPACK FOOTER //
// ./src/components/ListSlatePlugin/ListBulletedNode.js